import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IFormQuestion } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FormQuestionType } from '@fi-shared/fi-form-shared/fi-form-enums';
import { FormQuestionDeleteOptions } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/form-question-delete-type';
import { FiFormEditConfirmQuestionDeleteDialogComponent } from '@fi-app/fi-form/fi-form-edit/fi-form-edit-form/fi-form-edit-confirm-question-delete-dialog/fi-form-edit-confirm-question-delete-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-form-question-menu',
    templateUrl: './fi-form-question-menu.component.html',
    styleUrls: ['./fi-form-question-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-question-menu' },
    standalone: false,
})
export class FiFormQuestionMenuComponent {
    @Input() question: IFormQuestion;
    @Output() toggleDisabled = new EventEmitter<void>();
    @Output() toggleMandatory = new EventEmitter<void>();
    @Output() deleteQuestion = new EventEmitter<void>();

    private readonly disabledStateAvailableQuestionTypes: FormQuestionType[] = [
        FormQuestionType.Text,
        FormQuestionType.Numeric,
        FormQuestionType.SingleChoice,
        FormQuestionType.MultipleChoice,
    ];
    private readonly mandatoryStateAvailableQuestionTypes: FormQuestionType[] = [
        FormQuestionType.Text,
        FormQuestionType.Numeric,
        FormQuestionType.SingleChoice,
        FormQuestionType.MultipleChoice,
        FormQuestionType.Attachment,
    ];
    private readonly skipDeleteConfirmationDialogQuestionTypes: FormQuestionType[] = [
        FormQuestionType.Attachment,
        FormQuestionType.MediaBank,
    ];

    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    isQuestionDisabledStateAvailable(): boolean {
        return this.disabledStateAvailableQuestionTypes.includes(this.question.Type);
    }

    isQuestionMandatoryStateAvailable(): boolean {
        return this.mandatoryStateAvailableQuestionTypes.includes(this.question.Type);
    }

    private isQuestionDeleteConfirmationSkipped(): boolean {
        return this.skipDeleteConfirmationDialogQuestionTypes.includes(this.question.Type);
    }

    toggleQuestionMandatoryState($event: MouseEvent) {
        $event.stopPropagation();
        this.toggleMandatory.emit();
    }

    toggleQuestionDisabledState($event: MouseEvent) {
        $event.stopPropagation();
        this.toggleDisabled.emit();
    }

    confirmQuestionDelete() {
        if (this.question.Id && !this.isQuestionDeleteConfirmationSkipped()) {
            this.showConfirmDeleteDialog();
        } else {
            this.deleteQuestion.emit();
        }
    }

    private showConfirmDeleteDialog() {
        this.fiDialogsService
            .custom({
                hideFooter: true,
                headerText: this.appTextService.get('delete_question_dialog_header'),
                contentComponentRef: FiFormEditConfirmQuestionDeleteDialogComponent,
                config: {
                    maxWidth: '625px',
                    minHeight: '220px',
                    autoFocus: false,
                },
            })
            .onYesButtonClick((response: number) => {
                if (response === FormQuestionDeleteOptions.Delete) {
                    this.deleteQuestion.emit();
                } else {
                    this.toggleDisabled.emit();
                }
            });
    }
}
